import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  userInfo: any = null;
  authModules: any = null;
  constructor() { }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/auth/auth.service.ts